// TODO: Ogni volta che si tocca qui, allineare relativi metodi su utilityfunctions

export enum OrderLabelTypeEnum {
  Unknown = 0,
  Grinta = 1,
  Edicom = 2,
  Kustom = 3,
  MonthlyGrinta = 4,
  Shopify = 5,
  KustomRestocking = 6,
  B2BSHOP_DWEB = 7,
  B2BSHOP_HEROES = 8,
  B2BSHOP_KOI = 9,
  B2BSHOP_MARIN = 10,
  B2BSHOP_REAL = 11,
  B2BSHOP_RIAZOR = 12,
  B2BSHOP_VALLSUR = 13,
  B2BSHOP_ZORRILLA = 14,
  B2BSHOP_KSIHQ = 15,
  WH_DWEB = 16,
  WH_HEROES = 17,
  WH_KOI = 18,
  WH_MARIN = 19,
  WH_REAL = 20,
  WH_RIAZOR = 21,
  WH_VALLSUR = 22,
  WH_ZORRILLA = 23,
  WH_KSIHQ = 24,
  B2BSHOP_UNIPREUS = 25,
  B2BSHOP_CADWEB = 26,
  B2BSHOP_CADBAH = 27,
  B2BSHOP_CADMIR = 28,
  B2BSHOP_CADCEN = 29
}

